<template>
  <div
    class="flex items-center absolute top-5 gap-x-1 right-52"
    style="margin-top: -2px; width: calc(100% - 290px); right: 180px"
  >
    <text>报账金额合计:</text>
    <c_money :key="state.total" :value="state.total" bold :prefix="false" />
    <div class="flex justify-end flex-1 gap-x-1" style="margin-top: -8px">
      <li
        v-if="state.select_count > 0"
        class="text-sm text-gray-400 flex items-center mr-5"
      >
        已选
        <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
        条数据
        <el-button type="danger" link @click="onClearSelect">清空</el-button>
      </li>
      <el-button type="primary" link icon="Plus" @click="onShowXuNiXiang">
        添加虚拟项
      </el-button>
      <!-- <el-button type="success" link icon="Edit" @click="state.showEdit = true">
        明细项调整
      </el-button> -->
      <el-button type="primary" link icon="Select" @click="onMianShui(0)">
        设置免税
      </el-button>
      <el-button type="danger" link icon="Close" @click="onMianShui(1)">
        取消免税
      </el-button>
      <el-button type="primary" link icon="Select" @click="onTiCheng(1)">
        设置参与提成
      </el-button>
      <el-button type="danger" link icon="Close" @click="onTiCheng(0)">
        取消参与提成
      </el-button>
      <el-button link icon="Hide" @click="onHide(0)">隐藏已选</el-button>
      <el-tooltip
        content="隐藏的采购项将在生成报账单时自动忽略，且不参与计算。隐藏/取消隐藏后为保证数据的准确性，请重新生成报账单！"
      >
        <el-icon
          class="cursor-pointer"
          style="margin-top: 1.5px; margin-left: -6px"
          ><QuestionFilled
        /></el-icon>
      </el-tooltip>
      <el-button type="danger" link icon="Close" @click="onHide(1)">
        取消隐藏
      </el-button>
      <el-button type="danger" link icon="Delete" @click="onDelete()">
        删除虚拟采购项
      </el-button>
      <el-tooltip content="仅删除已勾选的虚拟采购项">
        <el-icon
          class="cursor-pointer"
          style="margin-top: 1.5px; margin-left: -6px"
          ><QuestionFilled
        /></el-icon>
      </el-tooltip>
    </div>
  </div>
  <div class="flex flex-col gap-y-5 overflow-hidden">
    <ul class="flex items-center gap-x-5 mt-2 flex-wrap gap-y-2">
      <c_params title="关键字">
        <template #default>
          <el-input
            v-model="state.params.keywords"
            placeholder="请输入关键字"
            class="!w-56"
            clearable
          ></el-input>
        </template>
      </c_params>
      <c_params title="乙方单位">
        <template #default>
          <el-select v-model="state.params.bill_unit_id" filterable class="!w-72">
            <template #label="{ value }">
              <div
                v-if="yfdw_map.get(value)"
                class="grid w-full items-center gap-x-10"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ yfdw_map.get(value).name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ yfdw_map.get(value).number }}
                </text>
              </div>
            </template>
            <el-option
              v-for="item in state.yfdw_data"
              :key="item.id"
              :label="`${item.name} ${item.number}`"
              :value="item.id"
            >
              <div
                class="grid w-full items-center gap-x-10"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ item.name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ item.number }}
                </text>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadYfdw()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </c_params>
      <c_params title="所属分会">
        <template #default>
          <el-select v-model="state.params.meeting_place_id" filterable class="!w-72">
            <template #label="{ value }">
              <div
                v-if="fh_map.get(value)"
                class="grid w-full gap-x-10 items-center"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ fh_map.get(value).name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ fh_map.get(value).hotel?.name + "-" + fh_map.get(value).hotelHall?.name }}
                </text>
              </div>
            </template>
            <el-option
              v-for="item in state.fh_data"
              :key="item.id"
              :label="`${item.name} ${item.hotel?.name} ${item.hotelHall?.name}`"
              :value="item.id"
            >
              <div
                class="grid w-full gap-x-10 items-center"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ item.name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ item.hotel?.name + "-" + item.hotelHall?.name }}
                </text>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadFh()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </c_params>
      <c_params title="供应商">
        <template #default>
          <el-select v-model="state.params.supplier_id" filterable class="!w-72">
            <template #label="{ value }">
              <div
                v-if="gys_map.get(value)"
                class="grid w-full items-center gap-x-10"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ gys_map.get(value).name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ gys_map.get(value).number }}
                </text>
              </div>
            </template>
            <el-option
              v-for="item in state.gys_data"
              :key="item.id"
              :label="`${item.name} ${item.number}`"
              :value="item.id"
            >
              <div
                class="grid w-full items-center gap-x-10"
                style="grid-template-columns: 1fr auto"
              >
                <text>{{ item.name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ item.number }}
                </text>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadYfdw()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </c_params>
      <c_params title="采购类型">
        <template #default>
          <el-tree-select
            v-model="state.d_cost_type_id"
            :data="state.lx_data"
            node-key="id"
            :props="{
              children: 'children',
              label: 'name',
            }"
            :expand-on-click-node="false"
            clearable
            default-expand-all
            class="!w-40"
            :check-strictly="true"
            @current-change="onCblxParamsChange"
            @clear="
              delete state.params.d_cost_type_pid;
              delete state.params.d_cost_type_id;
            "
          >
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadCblx"
              >
                刷新
              </el-button>
            </template>
          </el-tree-select>
        </template>
      </c_params>
      <el-button type="primary" @click="onLoad">查询</el-button>
      <li class="flex-1">
        <el-button
          type="info"
          link
          icon="Refresh"
          @click="onReset()"
          style="margin-left: -10px"
        >
          重置
        </el-button>
      </li>
      <el-tooltip
        content="该功能仅保存列表中所有明细项的类型、报账单价、报账数量、天数及备注的调整。窗口头部操作按钮(设置免税、设置不参与提成、隐藏等操作确认后及时生效！)"
      >
        <el-button type="success" icon="Hide" @click="onSubmit">
          保存调整
          <el-icon class="cursor-pointer">
            <QuestionFilled />
          </el-icon>
        </el-button>
      </el-tooltip>
    </ul>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      class="flex-1"
      row-key="id"
      ref="tableDom"
      @selection-change="onSelectChange"
      @row-click="onRowClick"
      :row-style="onSetRowBg"
    >
      <el-table-column type="selection" width="55" reserve-selection />
      <el-table-column :min-width="200">
        <template #header>
          <div class="c-table-col-header" label1="所属分会" label2="乙方单位" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>{{ row.meetingPlace?.name }}</text>
            </template>
            <template #bottom>
              <text>{{ row.billUnit?.name }}</text>
              <text class="text-gray-400 text-xs ml-1">
                {{ "[" + row.billUnit?.number + "]" }}
              </text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :min-width="200">
        <template #header>
          <div class="c-table-col-header" label1="采购名称" label2="供应商" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <span
                v-if="row.is_virtual"
                class="w-3 h-3 bg-blue-300 text-white rounded-s-sm mr-1 text-center overflow-hidden cursor-pointer"
                style="font-size: 11px; padding: 2px"
                title="虚拟采购项"
                >虚</span
              >
              <text>
                {{ row.meetingPurchase?.name }}
              </text>
              <text class="text-gray-400 text-xs ml-1">
                {{ row.meetingPurchase?.number }}
              </text>
            </template>
            <template #bottom>
              <div v-if="row.supplier_id" class="flex items-center gap-x-1">
                <text>{{ row.supplier?.name }}</text>
                <text class="text-gray-400 text-xs">
                  {{ row.supplier?.number }}
                </text>
              </div>
              <text v-else>-</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :min-width="120">
        <template #header>
          <div class="c-table-col-header" label1="采购项" label2="规格" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <strong>{{ row.name }}</strong>
            </template>
            <template #bottom>
              <text>{{ row.specification }}</text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="采购合计" :width="100" align="center">
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <text>{{ row.amount }}</text>
            </template>
            <template #bottom>
              <text>
                {{ row.price + "*" + row.count + row.d_measure_unit_name }}
              </text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="类型" :width="140">
        <template #default="{ row, $index }">
          <el-select
            v-model="row.d_cost_type"
            placeholder=""
            value-key="id"
            :title="row.d_cost_type_name"
            @change="
              (item) => {
                row.d_cost_type_pid = item.pid;
                row.d_cost_type_id = item.id;
                row.d_cost_type_name = item.name;
              }
            "
            @click.stop=""
            :ref="(el) => setInputRef(el, $index, 'd_cost_type')"
            @keydown="handleKeydown($event, $index, 'd_cost_type')"
          >
            <el-option
              v-for="item in state.lx_data"
              :key="item"
              :label="item.name"
              :value="item"
            />
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadLx(true)"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="报账单价" align="center" :width="140">
        <template #default="{ row, $index }">
          <!-- <el-input-number
            v-model="row.bill_price"
            class="!w-full"
            precision="2"
            placeholder="报账单价"
            @focus="$onFocus"
            @change="onBuildRowTotal(row)"
            @click.stop=""
          /> -->
          <el-input
            type="number"
            v-model="row.bill_price"
            class="no-arrow-input"
            input-style="text-align: center"
            @focus="$onFocus"
            placeholder="报账单价"
            @blur="onPriceBlur(row, 'bill_price')"
            :ref="(el) => setInputRef(el, $index, 'bill_price')"
            @keydown="handleKeydown($event, $index, 'bill_price')"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" :width="160">
        <template #header>
          <div class="flex items-center gap-x-1 justify-center">
            <div
              class="c-table-col-header"
              label1="报账数量"
              label2="天数"
            ></div>
          </div>
        </template>
        <template #default="{ row, $index }">
          <div class="grid grid-cols-2 gap-x-1">
            <el-input
              type="number"
              v-model="row.bill_count"
              class="no-arrow-input"
              input-style="text-align: center"
              @focus="$onFocus"
              placeholder="数量"
              @blur="onBuildRowTotal(row)"
              :ref="(el) => setInputRef(el, $index, 'bill_count')"
              @keydown="handleKeydown($event, $index, 'bill_count')"
            />
            <el-input
              type="number"
              v-model="row.bill_day_count"
              class="no-arrow-input"
              input-style="text-align: center"
              @focus="$onFocus"
              @blur="onBuildRowTotal(row)"
              :ref="(el) => setInputRef(el, $index, 'bill_day_count')"
              @keydown="handleKeydown($event, $index, 'bill_day_count')"
            />
            <!-- <el-input-number
              v-model="row.bill_count"
              class="!w-full"
              placeholder="数量"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
              @click.stop=""
            />
            <el-input-number
              v-model="row.bill_day_count"
              class="!w-full"
              placeholder="1"
              @focus="$onFocus"
              @change="onBuildRowTotal(row)"
              @click.stop=""
              :min="1"
            /> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" :width="260">
        <template #default="{ row, $index }">
          <el-input
            v-model="row.bill_remark"
            @focus="$onFocus"
            @click.stop=""
            :ref="(el) => setInputRef(el, $index, 'bill_remark')"
            @keydown="handleKeydown($event, $index, 'bill_remark')"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="报账金额"
        prop="bill_amount"
        align="right"
        :formatter="$tab_MoneyFormat"
        :width="100"
      />
      <el-table-column label="状态" align="center">
        <template #default="{ row }">
          <div
            class="flex gap-x-1 cursor-pointer justify-center flex-wrap gap-y-1"
            v-if="
              !row.is_include_tax_fee ||
              row.is_include_commission ||
              !row.is_show_bill
            "
          >
            <el-tooltip content="已设置免税" v-if="!row.is_include_tax_fee">
              <el-tag size="small" type="success">免税</el-tag>
            </el-tooltip>
            <el-tooltip
              content="已设置参与提成"
              v-if="row.is_include_commission"
            >
              <el-tag size="small" type="danger">参与提成</el-tag>
            </el-tooltip>
            <el-tooltip content="已隐藏，不参与报账" v-if="!row.is_show_bill">
              <el-tag size="small" type="info">隐藏</el-tag>
            </el-tooltip>
          </div>
          <text v-else>-</text>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="state.showAdd"
      title="添加虚拟项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showAdd = false;
        }
      "
      width="95%"
      style="height: 90%; max-height: 90%"
      modal
    >
      <c_add
        :meeting_id="props.meeting_id"
        :meeting_bill_id="props.meeting_bill_id"
        @close="
          state.showAdd = false;
          onLoad();
        "
      />
    </el-dialog>
    <el-dialog
      v-model="state.showEdit"
      title="费用明细项调整"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showEdit = false;
        }
      "
      width="95%"
      style="height: 90%; max-height: 90%"
      modal
    >
      <c_edit
        :meeting_id="props.meeting_id"
        :meeting_bill_id="props.meeting_bill_id"
        @refresh="onLoad()"
      />
    </el-dialog>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue";
import {
  meeting_bill_item_page,
  meeting_bill_record_updateIsIncludeCommission,
  meeting_bill_record_updateIsIncludeTaxFee,
  meeting_bill_record_updateIsShowBill,
  meeting_bill_item_editBatch,
  meeting_bill_item_delete,
} from "@/http/meeting";
import {
  data_getBillUnit,
  data_getMeetingPlace,
  data_getSupplier,
  dic_getCostType,
} from "@/http/data";
import { ElMessageBox, ElMessage } from "element-plus";
import { toDecimal, formatDecimal } from "@/utils/funcs";
import { priceFormat } from "@/utils/format";

import c_add from "./Add/Info.vue";
import c_edit from "./Edit.vue";

export default {
  components: { c_add, c_edit },
  props: {
    meeting_id: Number, //会议Id
    meeting_bill_id: Number, //会议报账单Id
    search: Boolean,
  },
  setup(props) {
    const row_bgs = ["#fff", "#F5F5F5", "#fff"]; //行背景
    let gyss = []; //列表中的供应商集合
    let list_source; //列表数据源
    const tableDom = ref(null);
    const state = reactive({
      params: {
        meeting_id: props.meeting_id,
        limit: 0,
      },
    });
    onMounted(() => {
      onLoadYfdw();
      onLoadFh();
      onLoadGys();
      onLoadCblx();
      if (props.meeting_bill_id) {
        state.params.meeting_bill_id = props.meeting_bill_id;
      }

      onLoad();
    });

    //获取乙方单位
    const onLoadYfdw = () => {
      data_getBillUnit().then((res) => {
        if (res.status == 200) state.yfdw_data = res.data?.data?.list || [];
      });
    };

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    //获取供应商
    const onLoadGys = () => {
      data_getSupplier().then((res) => {
        if (res.status == 200) state.gys_data = res.data?.data?.list || [];
      });
    };

    //获取成本类型
    const onLoadCblx = () => {
      dic_getCostType().then((res) => {
        if (res.status == 200) {
          const { data } = res.data;
          state.lx_data = data;
        }
      });
    };

    //乙方单位 id 索引，O(1) 查找
    const yfdw_map = computed(() => {
      const m = new Map();
      state.yfdw_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //分会 id 索引，O(1) 查找
    const fh_map = computed(() => {
      const m = new Map();
      state.fh_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //供应商 id 索引，O(1) 查找
    const gys_map = computed(() => {
      const m = new Map();
      state.gys_data?.forEach((item) => m.set(item.id, item));
      return m;
    });

    //成本类型查询条件改变事件
    const onCblxParamsChange = (item) => {
      if (item.pid) {
        state.params.d_cost_type_pid = item.pid;
        state.params.d_cost_type_id = item.id;
      } else {
        state.params.d_cost_type_pid = item.id;
        delete state.params.d_cost_type_id;
      }
    };

    const onLoad = () => {
      delete state.list_data;

      meeting_bill_item_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, statistics } = res.data?.data;
          state.list_data = list.map((m) => {
            return {
              ...m,
              d_cost_type: { id: m.d_cost_type_id },
              bill_day_count:
                !m.bill_day_count || m.bill_day_count == "0.00"
                  ? ""
                  : formatDecimal(m.bill_day_count),
            };
          });
          list_source = JSON.parse(JSON.stringify(list));

          state.totalCount = count;
          state.statistics = statistics;
          state.total = statistics.total_bill_amount;
          list.reduce((pre, cur) => {
            if (!gyss.some((w) => w.supplier_id == cur.supplier_id)) {
              gyss.push({
                supplier_id: cur.supplier_id,
                bgColor: row_bgs[gyss.length % 3],
              });
            }
            return pre;
          }, gyss);
        }
      });
    };

    //行点击事件
    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);

      // const rows = tableDom.value.getSelectionRows();
      // if (rows.some((w) => w.id == item)) {
      //   tableDom.value.toggleRowSelection(item);
      // } else {
      //   if (!item.is_generate_record) {
      //     tableDom.value.toggleRowSelection(item);
      //   } else {
      //     ElMessage.warning("该明细项已生成报账单，请勿重复操作！");
      //   }
      // }
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
    };

    //重置查询条件
    const onReset = () => {
      state.params = {
        meeting_id: props.meeting_id,
        limit: 0,
      };
      delete state.d_cost_type_id;
      onLoad();
    };

    //设置行背景色
    const onSetRowBg = ({ row }) => {
      const gys = gyss.find((w) => w.supplier_id == row.supplier_id);
      if (gys) {
        return { background: gys.bgColor };
      } else {
        return { background: "#fff" };
      }
    };

    //设置是否免税
    const onMianShui = (status) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }
      ElMessageBox.confirm(
        `您确定将已选<strong style='color:#080'>${
          rows.length
        }</strong>条采购项<strong style='color:var(${
          status ? "--el-color-danger" : "--el-color-success"
        })'>${status ? "取消免税" : "设置免税"}</strong>吗？`,
        status ? "取消免税" : "设置免税",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_bill_record_updateIsIncludeTaxFee({
          id: rows.map((m) => m.id).join(","),
          is_include_tax_fee: status,
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data?.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                onLoad();
                tableDom.value.clearSelection();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    //设置参与/不参与提成
    const onTiCheng = (status) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }

      ElMessageBox.confirm(
        `您确定将已选<strong style='color:#080'>${
          rows.length
        }</strong>条采购项<strong style='color:var(${
          status ? "--el-color-success" : "--el-color-danger"
        })'>${status ? "设置参与提成" : "取消参与提成"}</strong>吗？`,
        status ? "设置参与提成" : "取消参与提成",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_bill_record_updateIsIncludeCommission({
          id: rows.map((m) => m.id).join(","),
          is_include_commission: status,
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data?.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                onLoad();
                tableDom.value.clearSelection();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    //隐藏/取消隐藏
    const onHide = (status) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }

      meeting_bill_record_updateIsShowBill({
        id: rows.map((m) => m.id).join(","),
        is_show_bill: status,
      }).then((res) => {
        if (res.status == 200) {
          ElMessageBox.alert(res.data?.msg, "提示", {
            dangerouslyUseHTMLString: true,
            type: "success",
            callback: () => {
              onLoad();
              tableDom.value.clearSelection();
            },
          });
        } else {
          ElMessage({
            message: res.data,
            type: "error",
          });
        }
      });
    };

    //采购单价、数量、天数改变时，计算行内合计，合计=采购单价*数量*天数
    const onBuildRowTotal = (row) => {
      row.bill_amount = toDecimal(row.bill_price)
        .times(toDecimal(row.bill_count))
        .times(toDecimal(row.bill_day_count || "1"));

      onBuildTotal();
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.list_data
        .filter((w) => w.is_show_bill)
        .reduce((pre, cur) => {
          return pre.plus(toDecimal(cur.bill_amount?.toString() || ""));
        }, toDecimal("0"));
      state.total = total;
    };

    const onSubmit = () => {
      ElMessageBox.confirm(`您确定修改费用明细吗`, "修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        customClass: "c-delete-dialog",
        cancelButtonClass: "is-plain",
      }).then(() => {
        meeting_bill_item_editBatch({
          batch_data: state.list_data,
        }).then((res) => {
          if (res.status == 200) {
            onLoad();
            tableDom.value.clearSelection();
          }
        });
      });
    };

    const onShowXuNiXiang = () => {
      let isEdit = false;
      state.list_data.forEach((e, i) => {
        if (!isEdit) {
          let source_item = list_source[i];
          if (
            e.d_cost_type_id != source_item.d_cost_type_id ||
            toDecimal(e.bill_price).toNumber() !=
              toDecimal(source_item.bill_price).toNumber() ||
            toDecimal(e.bill_count).toNumber() !=
              toDecimal(source_item.bill_count).toNumber() ||
            toDecimal(e.bill_day_count).toNumber() !=
              toDecimal(source_item.bill_day_count).toNumber()
          ) {
            isEdit = true;
          }
        }
      });

      if (isEdit) {
        ElMessageBox.confirm(
          `当前页面部分明细项已调整，尚未保存，是否立即保存？`,
          "保存",
          {
            type: "warning",
            confirmButtonText: "保存后继续",
            cancelButtonText: "不保存",
            dangerouslyUseHTMLString: true,
            customClass: "c-delete-dialog",
            cancelButtonClass: "is-plain",
          },
        )
          .then(() => {
            meeting_bill_item_editBatch({
              batch_data: state.list_data,
            })
              .then((res) => {
                state.showAdd = true;
              })
              .catch(() => {
                state.showAdd = true;
              });
          })
          .catch(() => {
            state.showAdd = true;
          });
      } else {
        state.showAdd = true;
      }
    };

    //价格输入框失去焦点后格式化内容
    const onPriceBlur = (row, field) => {
      const data = parseFloat(row[field]).toFixed(2);
      if (data && data != "NaN") {
        row[field] = data;
      } else {
        row[field] = "";
      }

      onBuildRowTotal(row);
    };

    // 收集ref
    const setInputRef = (el, rowIndex, field) => {
      const key = `${rowIndex}|${field}`;
      if (el) {
        inputRefs.value[key] = el;
      } else {
        delete inputRefs.value[key];
      }

      // 给 el‑input‑number 原生input绑定监听，屏蔽内部上下键
      if (el?.input) {
        el.input.addEventListener("keydown", (e) => {
          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }
    };

    // 存储input实例：key格式 "行号|字段名"
    const inputRefs = ref({});

    const handleKeydown = (e, rowIndex, field) => {
      const fieldList = [
        "d_cost_type",
        "bill_price",
        "bill_count",
        "bill_day_count",
        "bill_remark",
      ]; // 列顺序，控制左右移动

      const colIndex = fieldList.indexOf(field);
      const maxRow = tableDom.value.length - 1;

      let targetRow = rowIndex;
      let targetCol = colIndex;

      switch (e.key) {
        case "ArrowUp":
          e.preventDefault(); // 阻止光标在文本内部跳动
          e.stopPropagation();
          if (rowIndex != 0) targetRow = rowIndex - 1;
          break;
        case "ArrowDown":
          e.preventDefault();
          e.stopPropagation();
          if (rowIndex != maxRow - 1) targetRow = rowIndex + 1;
          break;
        case "ArrowLeft":
          // 如果光标已经在文本最左侧，才跳到上一列
          e.preventDefault();
          e.stopPropagation();
          if (colIndex > 0) targetCol -= 1;
          break;
        case "ArrowRight":
          e.preventDefault();
          e.stopPropagation();
          console.log(colIndex);

          if (colIndex < fieldList.length) targetCol += 1;
          break;
        default:
          return;
      }
      const targetField = fieldList[targetCol];
      const targetKey = `${targetRow}|${targetField}`;
      const targetInput = inputRefs.value[targetKey];

      if (targetInput) {
        targetInput.focus();
      }
    };

    //删除虚拟采购项
    const onDelete = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }

      if (rows.some((w) => !w.is_virtual)) {
        ElMessage.warning(
          "已勾选的采购项中包含非虚拟采购项，禁止删除！请重新勾选",
        );
        return;
      }

      ElMessageBox.confirm(
        `您确定要<strong style='color:#f00'>删除</strong>已勾选<strong style='color:#1e90ff'>${rows.length}</strong>条虚拟采购项吗？`,
        "删除虚拟采购项",
        {
          type: "warning",
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_bill_item_delete({
          id: rows.map((m) => m.id).join(","),
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data?.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                onLoad();
                tableDom.value.clearSelection();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    return {
      state,
      props,
      yfdw_map,
      fh_map,
      gys_map,
      onLoad,
      onLoadYfdw,
      onLoadFh,
      tableDom,
      onSelectChange,
      onRowClick,
      onClearSelect,
      onLoadGys,
      onSetRowBg,
      onMianShui,
      onTiCheng,
      onHide,
      onReset,
      onBuildRowTotal,
      onSubmit,
      onCblxParamsChange,
      onShowXuNiXiang,
      handleKeydown,
      setInputRef,
      onPriceBlur,
      onDelete,
    };
  },
};
</script>

<style lang="less" scoped></style>
